import {useCallback, useEffect, useState} from "react";
import {Link, Navigate} from "react-router-dom";
import {Show, UserButton} from "@clerk/react";
import {ExternalLink, ShieldAlert} from "lucide-react";
import {useCmsApi} from "@/components/cms/common";
import {OutletsTab} from "@/components/cms/OutletsTab";
import {ServicesTab} from "@/components/cms/ServicesTab";
import {PackagesTab} from "@/components/cms/PackagesTab";
import {SettingsTab} from "@/components/cms/SettingsTab";
import {UsersTab} from "@/components/cms/UsersTab";
import {LOGO_ON_WHITE} from "@/lib/inner";

const TABS = [["outlets", "Outlet"], ["services", "Menu & Harga"], ["packages", "Paket Favorit"], ["settings", "Membership & Notifikasi"], ["users", "Pengguna CMS"]];

const CmsHeader = () => (
  <header className="topbar"><Link className="brand" to="/cms"><img src={LOGO_ON_WHITE} alt="INNER"/><span className="cms-badge">CMS</span></Link>
    <nav><a href="/" target="_blank" rel="noreferrer" data-testid="cms-view-site">Lihat situs <ExternalLink size={13}/></a><UserButton/></nav></header>
);

function CmsApp() {
  const call = useCmsApi();
  const [me, setMe] = useState(null), [data, setData] = useState(null), [tab, setTab] = useState("outlets"), [error, setError] = useState("");
  const reload = useCallback(() => call("get", "/data").then(setData), [call]);
  useEffect(() => {
    call("get", "/me").then(m => { setMe(m); if (m.role === "admin") reload(); }).catch(() => setError("Tidak dapat memuat akun. Muat ulang halaman."));
  }, [call, reload]);
  if (error) return <main className="cms-page"><p className="error">{error}</p></main>;
  if (!me) return <main className="cms-page"><p className="muted">Memuat…</p></main>;
  if (me.role !== "admin") return <main className="cms-page cms-denied" data-testid="cms-access-denied"><ShieldAlert/><h1>Akses <em>belum diberikan.</em></h1><p className="muted">Akun {me.email} belum menjadi admin CMS. Minta admin website untuk memberikan akses.</p></main>;
  if (!data) return <main className="cms-page"><p className="muted">Memuat data…</p></main>;
  return <main className="cms-page" data-testid="cms-page">
    <p className="eyebrow">ADMIN WEBSITE</p>
    <h1>Kelola <em>konten.</em></h1>
    <div className="cms-tabs" role="tablist">{TABS.map(([k, t]) => <button key={k} data-testid={`cms-tab-${k}`} className={tab === k ? "active" : ""} onClick={() => setTab(k)}>{t}</button>)}</div>
    {tab === "outlets" && <OutletsTab items={data.branches} call={call} reload={reload}/>}
    {tab === "services" && <ServicesTab items={data.services} categories={data.categories} call={call} reload={reload}/>}
    {tab === "packages" && <PackagesTab items={data.packages} services={data.services} categories={data.categories} call={call} reload={reload}/>}
    {tab === "settings" && <SettingsTab settings={data.settings} call={call} reload={reload}/>}
    {tab === "users" && <UsersTab call={call} me={me}/>}
  </main>;
}

export default function Cms() {
  return <>
    <Show when="signed-in"><CmsHeader/><CmsApp/></Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace/></Show>
  </>;
}
